export const CURRENCY_RATE_STORAGE_ID = 'currencyRates';
